export default __webpack_public_path__ + "static/press-release-itb2023-d5c1e53a95907144cbf244b1d08e660e.jpg";